import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {FormioCustomComponent} from "@formio/angular";
import {PortalArticlesComponent} from "../portal-articles/portal-articles.component";

@Component({
  selector: 'sb-portal-infinite-scroll,sb-dynamic-portal-infinite-scroll',
  templateUrl: './portal-infinite-scroll.component.html',
  styleUrls: ['./portal-infinite-scroll.component.scss']
})
export class PortalInfiniteScrollComponent implements FormioCustomComponent<string>, OnInit, AfterViewInit, OnDestroy {

  @ViewChild('articles')
  articlesAnchor: ElementRef<HTMLElement>;

  private articlesObserver: IntersectionObserver;

  @ViewChild(PortalArticlesComponent)
  articles: PortalArticlesComponent;


  @Input()
  disabled: boolean;

  @Input()
  value: string;

  @Output()
  valueChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    const options = {
      root: null,
      threshold:  [0, 0.25, 0.5, 0.75, 1]
    };

    this.articlesObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && this.articles) {
        this.articles.loadMore();
      }
    }, options);

    this.articlesObserver.observe(this.articlesAnchor.nativeElement);
  }

  ngOnDestroy(): void {
  }
}
